export default __webpack_public_path__ + "static/11.10-08dc0a864761ff61bb20ff83e81f7e48.png";